"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformObjectValuesToStrings = transformObjectValuesToStrings;
const cloneDeepWith_1 = __importDefault(require("lodash/cloneDeepWith"));
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const toString_1 = __importDefault(require("lodash/toString"));
// FCM want to have payload with strings only, no bool, no int
function transformObjectValuesToStrings(obj) {
    return (0, cloneDeepWith_1.default)(obj, (value) => {
        if (!(0, isPlainObject_1.default)(value) && value != null) {
            return (0, toString_1.default)(value);
        }
        return undefined;
    });
}
//# sourceMappingURL=transformObjectValuesToStrings.js.map